import { render, staticRenderFns } from "./GalleriesItemView.vue?vue&type=template&id=4107a074&scoped=true&"
import script from "./GalleriesItemView.vue?vue&type=script&lang=js&"
export * from "./GalleriesItemView.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesItemView.vue?vue&type=style&index=0&id=4107a074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4107a074",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
